import api from "@core/plugins/api";
import { BatchDTO } from "@core/dto";
import { Logger } from "@core/helpers/logger.helpers";
import { APP_CANDIDATE } from "@core/constants";

const getCandidateCustomIdUrl = () => `ex/candidate-device/register`;
const getEtabCustomIdUrl = () => `/et/device/register`;

export class PushNotifService {
  static async getCustomId({ operatingSystem, installationId, osVersion, env } = {}) {
    try {
      const dto = new BatchDTO({ operatingSystem, installationId, osVersion });
      const data = dto.postActivateBatchData();
      if (env === APP_CANDIDATE) {
        return api.private.post(getCandidateCustomIdUrl(), data);
      }
      return api.private.post(getEtabCustomIdUrl(), data);
    } catch (error) {
      return Logger.error(`CandidatesPushNotifService.getCustomId - error on post/${getCandidateCustomIdUrl()}`, error);
      // fail silently
    }
  }

  static async getEtabCustomId({ operatingSystem, installationId, osVersion } = {}) {
    try {
      const dto = new BatchDTO({ operatingSystem, installationId, osVersion });
      const data = dto.postActivateBatchData();
      return api.private.post(getEtabCustomIdUrl(), data);
    } catch (error) {
      return Logger.error(`CandidatesPushNotifService.getCustomId - error on post/${getEtabCustomIdUrl()}`, error);
      // fail silently
    }
  }
}
